module.exports = JSON.parse('{"Series is tracked":"Serie wordt gevolgd","Series is untracked":"Serie wordt niet gevolgd","Viewport":"Viewport"}')